import { LoadableLazy } from '@confluence/loadable';

export const PublishHubDialogLoadable = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-PublishHubDialogLoadable" */ './PublishHubDialog.tsx'))
			.PublishHubDialog,
});
